var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-clamp',{style:(_vm._style),attrs:{"autoresize":"","max-lines":_vm._maxLines},scopedSlots:_vm._u([{key:"after",fn:function(ref){
var toggle = ref.toggle;
var expanded = ref.expanded;
var clamped = ref.clamped;
return [(expanded || clamped)?_c('v-icon',{attrs:{"x-small":""},on:{"click":function($event){$event.stopPropagation();return toggle.apply(null, arguments)}}},[_vm._v(_vm._s(clamped ? 'show more' : 'show less'))]):_vm._e()]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }